import React, { Component } from 'react'
import Card from '../Card'
import css from './index.scss'

class Avatar extends Component {
  state = {
    picture: '',
  }
  render() {
    const size = this.props.size || ''
    return (
      <Card
        className={[css.card, css[size]].join(' ')}
        style={this.props.cardStyles}
      >
        <img
          src={this.props.src}
          className={css.avatar}
          alt={this.props.alt}
          onError={(e) => {
            e.target.src = this.props.noPicture || '/assets/icons/no-camera.svg'
            e.target.style = 'height: stretch; width: auto;'
          }}
        />
      </Card>
    )
  }
}

export default Avatar
